// import { FaHandPointRight } from "react-icons/fa";

const Intro = () => {
    return (
        <section id='intro'>
            <h2>Hakkında</h2>
            <p>
                Bu proje, hemşirelik lisans öğrencilerinin mesleki sorumluluklarını geliştirmek amacıyla, sağlık hukuku eğitiminin önemini vurgulamak ve bu konuda farkındalık kazandırmayı hedeflemektedir. Proje kapsamında, hemşirelik öğrencilerine şu başlıklarla detaylı bilgi sunulacaktır:
            </p>
            <div className="titles">
                <div className="title-card">
                    Hemşirelik Kanunu ve Yönetmeliği
                </div>
                <div className="title-card">
                    Hemşirelikte Profesyonel Değerler ve Davranışlar
                </div>
                <div className="title-card">
                    Adli Hemşirelik
                </div>
                <div className="title-card">
                    Hasta Hakları ve Güvenliği
                </div>
                <div className="title-card">
                    Türk Ceza Kanunu
                </div>
                <div className="title-card">
                    Malpraktis Davalar
                </div>
            </div>
            {/* <ul>
                <li>
                    <FaHandPointRight /> Hemşirelik Kanunu ve Yönetmeliği,
                </li>
                <li>
                    <FaHandPointRight /> Hemşirelikte Profesyonel Değerler ve Davranışlar,
                </li>
                <li>
                    <FaHandPointRight /> Adli Hemşirelik,
                </li>
                <li>
                    <FaHandPointRight /> Hasta Hakları ve Güvenliği,
                </li>
                <li>
                    <FaHandPointRight /> Türk Ceza Kanunu,
                </li>
                <li>
                    <FaHandPointRight /> Malpraktis Davaları
                </li>
            </ul> */}

            <p className="left-text">
                <strong>
                    Sorularınız için : <a href="mailto:ataunihemsirelik2237a@gmail.com">ataunihemsirelik2237a@gmail.com</a>
                </strong>
            </p>
            <p className="left-text">
                <strong>
                    Başvuru ve ayrıntılar için : <a href="https://forms.gle/1vPttqZXiE21PteC6" target="_blank" rel="noreferrer">https://forms.gle/1vPttqZXiE21PteC6</a>
                </strong>
            </p>
            <p className="attention">
                <strong>
                    Katılımcıların yol, konaklama ve iaşe giderleri TÜBİTAK tarafından karşılanacaktır.
                </strong>
            </p>

            {/* <p>
                <strong>
                    Etkinlik Zoom adresi : <a href="https://zoom.us/j/92625239840">https://zoom.us/j/92625239840</a>
                </strong>
            </p> */}
        </section>
    )
}

export default Intro